
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useEffect, useState } from "react";

const VerificationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Check for error parameters in hash or search params
    const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
    const searchParams = new URLSearchParams(location.search);
    
    const errorCode = hashParams.get('error_code') || searchParams.get('error_code');
    const errorDescription = hashParams.get('error_description') || searchParams.get('error_description');
    
    if (errorCode) {
      console.error('Verification error detected:', errorCode, errorDescription);
      let errorMessage = errorDescription || 'An verification error occurred.';
      
      if (errorCode === 'otp_expired') {
        errorMessage = 'The verification link has expired. Please request a new one.';
      }
      
      setError(errorMessage);
      
      // Clean the URL without reloading the page
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex justify-center">
            <img
              src="/diy-legal-logo.png"
              alt="DIYLegal Logo"
              style={{ height: '256px' }} // Using inline style to set exact height since Tailwind doesn't have a class for 256px
              className="w-auto mb-6"
              onError={(e) => {
                console.error('Error loading logo:', e);
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          {error ? (
            <>
              <Alert variant="destructive" className="mb-4">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
              <h1 className="text-2xl font-bold text-gray-900">Verification Failed</h1>
              <p className="text-gray-600">
                There was an issue verifying your email. Please return to the login page and request a new verification link.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-gray-900">Email Verified Successfully!</h1>
              <p className="text-gray-600">
                Your email has been successfully verified. You can now log in to your account.
              </p>
            </>
          )}
          <Button
            className="w-full"
            onClick={() => navigate("/auth")}
          >
            Go to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default VerificationSuccess;
